module.exports = __webpack_public_path__ + "img/Basic Setting.695221fe.svg";